import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { HHA_PROTOCOL_ITEMS } from './hhaProtocolConstants';

const HhaProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="HHA"
            title="HHA JOB DESCRIPTION"
            items={HHA_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default HhaProtocol;
